<template>
  <div class="clinic-list" v-loader.opacity="loading">
    <div class="no-results-box" v-if="alert.message">
      <BaseNoResults :title="alert.title" :text="alert.message"/>
    </div>

    <BaseTable class="no-border" v-if="tableArchivedClinic && session && !alert.message" :tabledata="tableArchivedClinic">
      <template v-slot:column_parent="{item}">
        <span v-if="item.parent">{{ item.parent.name }}</span>
        <span v-else>{{ $t('clinic.noParentClinic') }}</span>
      </template>

      <template v-slot:column_permission="{item}">
        <span class="label" :class="getPermissionClass(item)">
          {{ $t(item.userPermission) }}
        </span>
      </template>

      <template v-slot:column_actions="{item}">
        <button class="btn btn-success" type="button" name="button" @click.prevent.stop="confirmRestore(item)" v-if="item.userPermission == 'owner'">
          {{ $t('clinic.restore') }}
        </button>
      </template>
    </BaseTable>

    <teleport :to="`#${slotPagination}`" v-if="isDataReady">
      <div v-if="tableArchivedClinic" class="align-items-center page-row">
        <p class="pagination-total">{{ `${tableArchivedClinic.total} ${$t("pagination.clinics")}` }}</p>
          <BasePagination :total-pages="totalPages" :total="tableArchivedClinic.total"
                          :per-page="perPage" :current-page="currentPage" @pagechanged="onPageChange"/>
      </div>
    </teleport>

    <teleport to="body">
      <BaseGenericOffcanvas :offcanvas_id="'offcanvasExamDeleteGeneric'" ref="offcanvasGeneric" />
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
.clinic-list {
  padding:                           10px;
}

.vtable > tbody > tr > td {
  button {
    &:first-child {
      margin-right:                  5px;
    }
  }
}

.btn-success {
  font-size:                         11px !important;
  letter-spacing:                    1.32px;
  text-transform:                    capitalize;
  height:                            24px;
  padding:                           5px 10px !important;
}

.vtable-mob > ul > li p span.glyphicon {
  display:                           none;
}

@media (max-width: 400px) {
  .vtable-mob > ul > li {
    p {
      span:last-child {
        float:                       unset !important;
      }
    }
  }
}

@media (max-width: 991px) {
  .clinic-list {
    padding:                          0;
  }

  .inside-box-mob-item p {
    display:                          flex;
  }

  .clinic-list,
  .no-results-box {
    height:                          100%;
    text-align:                      center;
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'

export default {
  name: 'clinic-list',
  data: () => ({
    loading: false,
    alert: {
      title: null,
      message: null,
      class: null
    },
    tableArchivedClinic: null,
    perPage: 20,
    currentPage: 1,
    totalPages: 0,
    session: {
      collaborator: {},
      currentClinic: {}
    },
    isDataReady: false,
    slotPagination: 'settingsPagination',
  }),
  created() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
  },
  mounted: async function() {
    this.$activeLink.value = 'clinic'
    this.fetchData();

    this.handleResize()
    window.addEventListener('resize', this.handleResize);
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    async fetchData() {
      this.tableArchivedClinic = null

      this.loading = true
      NProgress.start()
      try {
        let params = {
          page: this.currentPage,
          deleted: true
        }

        let response = await this.$clinicService.getList(params);
        console.log('response clinic', response);
        this.loadTableData(response)
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      } finally {
        NProgress.done(true);
        this.loading = false
        this.isDataReady = true
      }
    },
    loadTableData(response) {
      this.alert = {}

      this.tableArchivedClinic = {
        'items': response.result,
        'total': response.totalCount,
        'columns': [
          {name: this.$i18n.t('createClinic.name'), type: 'string', value: 'name', width: '40%'},
          // {name: this.$i18n.t('clinic.totalUsers'), type: 'string', value: '', width: '25%'},
          {key: 'parent', name: this.$i18n.t('createClinic.parentClinic'), type: 'custom', value: 'parent.name', width: '25%'},
          {key: 'permission', name: this.$i18n.t('createClinic.permission'), type: 'custom', value: 'userPermission', width: '25%'},
          {key: "actions", name: '', type: 'custom', value: 'actions', width: '10%', align: 'text-center'},
        ]
      };

      this.totalPages = Math.ceil(response.totalCount / this.perPage);

      this.$nextTick(() => {
        let element = $(`.tr_${this.session.currentClinic.id} td:first-child`)
        if (element.find('span.label-info').length === 0) {
          element.append(`<span class="label label-success ms-2">${this.$i18n.t('createClinic.currentClinic')}</span> `)
        }
      })

      if (response.result.length === 0) {
        this.tableArchivedClinic = {};
        this.totalPages = 1
        this.alert = this.$message.alertWithTitle(this, 'request_notfound_archived_clinic_title', 'request_notfound_archived_clinic_text')
        // this.$message.popup(this, 'request_notfound', 'operationWarning', 'warn')
      }
    },
    getPermissionClass(item) {
      if (item.userPermission == 'admin') {
        return 'label-blue'
      } else if (item.userPermission == 'physician') {
        return 'label-green'
      } else if (item.userPermission == 'technician') {
        return 'label-purple'
      } else if (item.userPermission == 'specialist') {
        return 'label-warning'
      } else {
        return 'label-pink'
      }
    },
    handleResize() {
      this.slotPagination = window.innerWidth > 767 ? 'settingsPagination' : 'settingsPaginationMobile'
    },
    async confirmRestore(item) {
      const ok = await this.$refs.offcanvasGeneric.show({
        title: this.$i18n.t('confirm'),
        text: this.$i18n.t('clinic.confirmClinicRestore'),
        okButton: this.$i18n.t('clinic.restore'),
        okButtonClass: 'btn-success'
      })
      if (ok) {
        this.doRestore(item)
      }
    },
    async doRestore(item) {
      this.alert.message = null;

      let params = {
        clinic: {
          ...item,
          deleted: false
        }
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$clinicService.updateClinic(params)
        this.$message.popup(this, 'general.updatedSuccess', 'operationSuccess', 'success')

        this.fetchData()
      } catch (err) {
        this.$message.popup(this, 'general.updatedError', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'general.removedError', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
  }
}
</script>
